import { module } from "angular";
import { LoadingErrorComponent } from "./LoadingErrorComponent";

module("mmGui").component("mmLoadingError", new LoadingErrorComponent());
